import { Icon } from "@iconify/react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Chip,
} from "@nextui-org/react";

interface ProcessingHistoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  history: ProcessingHistory[];
  filename: string;
}

export const ProcessingHistoryModal = ({
  isOpen,
  onClose,
  history,
  filename,
}: ProcessingHistoryModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl">
      <ModalContent>
        <ModalHeader>Historial de Procesamiento - {filename}</ModalHeader>
        <ModalBody>
          <Table aria-label="Processing history">
            <TableHeader>
              <TableColumn>Fecha</TableColumn>
              <TableColumn>Estado</TableColumn>
              <TableColumn>Filas Procesadas</TableColumn>
              <TableColumn>Error</TableColumn>
            </TableHeader>
            <TableBody>
              {history.map((record) => (
                <TableRow key={record.id}>
                  <TableCell>
                    {new Date(record.created_at).toLocaleString("es-ES")}
                  </TableCell>
                  <TableCell>
                    <Chip
                      startContent={
                        record.status === "success" ? (
                          <Icon icon="tabler:circle-check" className="text-success" />
                        ) : record.status === "error" ? (
                          <Icon icon="tabler:circle-x" className="text-danger" />
                        ) : (
                          <Icon icon="tabler:loader-2" className="animate-spin" />
                        )
                      }
                      color={
                        record.status === "success"
                          ? "success"
                          : record.status === "error"
                          ? "danger"
                          : "warning"
                      }
                    >
                      {record.status}
                    </Chip>
                  </TableCell>
                  <TableCell>{record.processed_rows || "-"}</TableCell>
                  <TableCell>
                    <div className="max-w-md truncate">
                      {record.error_message || "-"}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
